export default {
  get(key) {
    if (!key) return null;

    const rCookie = new RegExp(`(^| )${key}=([^;]*)(;|$)`);
    const matchs = document.cookie.match(rCookie);
    if (matchs && matchs.length > 2) {
      return decodeURIComponent(matchs[2]);
    }
    return null;
  },
  /*
   * @params {String} key
   * @params {Any} value
   * @params {Object} options { domain, path, expires(days) }
   */
  set(key, value, options) {
    if (typeof value === 'undefined') return;

    const days = (options && options.expires) || 30;
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    let cookie = `${key}=${encodeURIComponent(value)};expires=${expires.toGMTString()}`;
    if (options) {
      if (options.domain) {
        cookie = `${cookie};domain=${options.domain}`;
      }
      if (options.path) {
        cookie = `${cookie};path=${options.path}`;
      }
    }
    document.cookie = cookie;
  },
  del(key, options) {
    if (typeof key === 'undefined') return;

    const expires = new Date();
    expires.setTime(expires.getTime() - 1);
    const value = this.get(key);
    let cookie = `${key}=${value};expires=${expires.toGMTString()}`;
    if (value != null) {
      cookie = `${key}=${value};expires=${expires.toGMTString()}`;
      if (options) {
        if (options.domain) {
          cookie = `${cookie};domain=${options.domain}`;
        }
        if (options.path) {
          cookie = `${cookie};path=${options.path}`;
        }
      }
      document.cookie = cookie;
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/core/cookie.js